export default function Features() {
  const features = [
    {
      icon: 'ri-shield-line',
      title: 'Advanced Security',
      description: 'Military-grade encryption protecting your data and privacy across all iOS devices with cutting-edge security protocols.',
      height: 'h-[340px]'
    },
    {
      icon: 'ri-code-s-slash-line',
      title: 'Clean Code Architecture',
      description: 'Built with modern Swift and SwiftUI, ensuring optimal performance, maintainability, and seamless integration with iOS ecosystem.',
      height: 'h-[380px]'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Performance',
      description: 'Optimized algorithms and efficient resource management deliver instant results without compromising device battery life.',
      height: 'h-[360px]'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Synchronization',
      description: 'Seamlessly sync your settings and preferences across multiple devices with secure cloud backup functionality.',
      height: 'h-[400px]'
    },
    {
      icon: 'ri-lock-line',
      title: 'Privacy First',
      description: 'Zero-log policy and complete transparency. Your data stays yours, with no tracking or third-party data sharing.',
      height: 'h-[370px]'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Real-time Analytics',
      description: 'Monitor your device performance, storage usage, and security status with intuitive dashboards and detailed insights.',
      height: 'h-[390px]'
    }
  ];

  return (
    <section id="features" className="py-20 px-20 bg-black max-w-[1440px] mx-auto">
      <div className="flex items-start justify-between mb-20">
        <div>
          <p className="text-[11px] uppercase tracking-[2px] font-light text-[#C9A961] mb-4">
            CORE FEATURES
          </p>
          <h2 className="text-[62px] leading-tight font-serif text-white">
            What Makes Us Different
          </h2>
        </div>
        
        <div className="w-12 h-12 rounded-full bg-[#C9A961]/20 flex items-center justify-center mt-8">
          <i className="ri-arrow-right-up-line text-[#C9A961] text-xl"></i>
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-10">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`${feature.height} rounded-[24px] bg-[#1A1A1A] p-12 hover:bg-[#222222] transition-colors duration-300`}
          >
            <div className="w-12 h-12 flex items-center justify-center mb-8">
              <i className={`${feature.icon} text-white text-5xl`}></i>
            </div>
            
            <h3 className="text-2xl font-medium text-white mb-4">
              {feature.title}
            </h3>
            
            <p className="text-base font-light leading-relaxed text-[#888888]">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
